import React from 'react'
import Link from 'gatsby-link'

import Dm from '../../../images/Dm.svg'
import Wb from '../../../images/Wb.svg'
import Bb from '../../../images/Bb.svg'
import Divider from '../../../images/Divider.svg'
import DividerW from '../../../images/DividerW.svg'
import Fill from '../../../images/Fill.svg'

const WebSolutions = () => (
  <section>
    <article>
      <div className='container'>
        <div className='full-Width'>
          <div className='half-Width-25 mobBottommargin' style={{}}>
            <div style={{display:'block'}}>
              <h1 className='smallerHone'>Services</h1>
              <img src={Divider} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
              <p><span className='biggerText gradient'>Strategy, design and a bit of magic.</span></p>
              <p style={{marginBottom:'0'}}>Nisadhya Pvt. Ltd is a Nepal based Digital Marketing Company that constantly strives to provide the best branding and digital marketing solutions.</p>
            </div>
          </div>
          <div className='half-Width-75 homeServicesContainer paddingLeft spaceBetween' style={{alignItems: 'baseline'}}>
            <div className='half-Width-30'>
              <div className='centerAlign homeServices'>
                <img src={Dm} alt="Digital Marketing in Nepal" />
                <Link to="/services/digital-marketing/" className='slide'><span>Digital Marketing</span></Link>
                <img src={Fill} alt="Nisadhya - Divider" style={{margin:'.75rem auto'}}/>
                Social Media<br/>
                Google Ads<br/>
                SEO
              </div>
            </div>
            <div className='half-Width-30'>
              <div className='centerAlign homeServices'>
                <img src={Wb} alt="Website Development in Nepal" />
                <Link to="/services/web-solutions/" className='slide'><span>Web Solutions</span></Link>
                <img src={Fill} alt="Nisadhya - Divider" style={{margin:'.75rem auto'}}/>
                Website Design<br/>
                Website Development<br/>
                Web Hosting
              </div>
            </div>
            <div className='half-Width-30'>
              <div className='centerAlign homeServices' style={{marginBottom:'0'}}>
                <img src={Bb} alt="Corporate Branding in Nepal" />
                <Link to="/services/brand-development/" className='slide'><span>Brand Development</span></Link>
                <img src={Fill} alt="Nisadhya - Divider" style={{margin:'.75rem auto'}}/>
                Corporate Branding<br/>
                Logo Design<br/>
                Brand Strategy
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <article>
      <div className="container">
        <div style={{display:'block'}}>
          <h1 className='smallerHone'>Web Solutions</h1>
          <img src={Divider} alt="Nisadhya - Divider" style={{margin:'.75rem 0'}}/>
          <p className='smallerHone'><span className='gradient'>Case studies such as these inspire and motivate us.</span></p>
          <p style={{marginBottom:'0'}}>See how businesses similar to yours are growing with Digital Marketing.</p>
        </div>
      </div>
    </article>
  </section>
)

export default WebSolutions



// WEBPACK FOOTER //
// ./src/pages/services/web-solutions/index.js